<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Journal Management / View</h1>
        </div>
        <div class="content-section">
            <div class="order-view max-WT setting-page">
                <div class="add-store-block input-style ">
                    <form>
                        <div class="form-group row align-items-baseline">
                            <div class="col-md-12">
                                <label class="mt-2">Question : </label>
                                <p> {{journalList?.question}} </p>
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline">
                            <div class="col-md-12">
                                <label class="mt-2">Created date : </label>
                                <!-- <p> {{faqList?.answer}} </p> -->
                                <p>{{journalList?.createdAt | date :'d/M/y' :'UTC'}}</p>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-theme" routerLink="/journal-mgt">Back</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</div>